export interface WorkExperience {
  id: string;
  company: string;
  position: string;
  period: string;
  duration: string;
  description: string;
  responsibilities: string[];
  achievements?: string[];
  managerComment?: string;
  technologies?: string[];
}

export interface ExperienceData {
  experiences: WorkExperience[];
}

export const experienceData: ExperienceData = {
  experiences: [
    {
      id: "rox-group",
      company: "ROX Group",
      position: "Senior Dynamics 365 & AI Solutions Engineer",
      period: "03/2026 - Now",
      duration: "7 months",
      description:
        "Design and deliver enterprise solutions on Microsoft Dynamics 365 and Dataverse, with AI-powered document processing.",
      responsibilities: [
        "Design and deliver enterprise solutions on Microsoft Dynamics 365 and Dataverse, focusing on CRM customization, business process automation, system integration, and solution optimization",
        "Develop and integrate AI-powered document processing solutions, including OCR, intelligent data extraction, document comparison, and automated document workflows using Python, FastAPI, and Azure",
        "Take ownership of the end-to-end technical lifecycle, from requirement analysis and solution design to implementation, deployment, troubleshooting, and continuous improvement",
      ],
      technologies: [
        "Dynamics 365",
        "Dataverse",
        "Python",
        "FastAPI",
        "Azure",
        "OCR",
        "AI",
      ],
    },
    {
      id: "tokyolife-pm",
      company: "Tokyolife",
      position: "Project Manager – Format E-commerce Web System",
      period: "12/2022 - 03/2026",
      duration: "3 years 4 months",
      description: "End-to-end delivery of a Magento 2 E-commerce web system.",
      responsibilities: [
        "Managed end-to-end delivery of a Magento 2 E-commerce web system using Agile/Scrum, from requirement analysis to production release",
        "Planned and controlled project scope, timeline, cost and risks using Jira (sprint planning, backlog grooming, burndown tracking)",
        "Acted as the central coordination point between business stakeholders, developers, QA and operations",
        "Defined delivery processes, release plans and quality gates; managed UAT, go-live and post-release support",
        "Oversaw system performance, scalability and operational readiness, coordinating Redis caching, RabbitMQ messaging and AWS/Docker deployment",
      ],
      technologies: [
        "Magento 2",
        "MySQL",
        "Redis",
        "RabbitMQ",
        "AWS",
        "Docker",
        "Agile/Scrum",
        "Jira",
        "Confluence",
      ],
    },
    {
      id: "tokyolife-lead",
      company: "Tokyolife",
      position: "Tech Leader – Tokyolife (E-commerce Platform)",
      period: "12/2022 - 03/2026",
      duration: "3 years 4 months",
      description:
        "Architecture and technical delivery of a large-scale E-commerce platform across mobile and backend systems.",
      responsibilities: [
        "Led architecture and technical delivery of a large-scale E-commerce platform across mobile and backend systems",
        "Designed and maintained microservices architecture using NestJS and Node.js, ensuring scalability and high availability",
        "Led React Native mobile development, optimizing performance, UX and release stability",
        "Implemented event-driven architecture with RabbitMQ and performance optimization using Redis caching",
        "Owned cloud infrastructure on AWS, containerized services with Docker, and led code reviews and production issue resolution",
      ],
      technologies: [
        "React Native",
        "NestJS",
        "Node.js",
        "MongoDB",
        "Redis",
        "Firebase",
        "RabbitMQ",
        "WebRTC",
        "Mediasoup",
        "AWS",
        "Docker",
      ],
    },
    {
      id: "tokyolife-forlife",
      company: "Tokyolife",
      position: "Tech Leader – Forlife Home (Internal Digitization Platform)",
      period: "12/2022 - 03/2026",
      duration: "3 years 4 months",
      description:
        "Technical strategy and system architecture for an internal digitization platform supporting multiple business departments.",
      responsibilities: [
        "Defined technical strategy and system architecture for an internal digitization platform supporting multiple business departments",
        "Designed modular backend services using NestJS and Node.js with a scalable, maintainable architecture",
        "Led development of internal mobile applications using React Native to digitize workflows and reporting",
        "Built asynchronous processing and workflow automation using RabbitMQ, with performance optimization via Redis",
        "Managed deployment and operations on AWS, containerized services with Docker, and established security and monitoring best practices",
      ],
      technologies: [
        "React Native",
        "NestJS",
        "Node.js",
        "MongoDB",
        "Redis",
        "Firebase",
        "RabbitMQ",
        "AWS",
        "Docker",
      ],
    },
    {
      id: "tokyolife-cms",
      company: "Tokyolife",
      position: "Backend Developer – Format CMS System",
      period: "12/2022 - 03/2026",
      duration: "3 years 4 months",
      description:
        "Backend services and RESTful APIs for a CMS system using .NET.",
      responsibilities: [
        "Developed backend services and RESTful APIs for a CMS system using .NET",
        "Designed and optimized SQL Server database schemas to ensure data integrity and performance",
        "Implemented Redis caching and RabbitMQ for asynchronous processing and background jobs",
        "Containerized backend services using Docker for consistent deployment across environments",
        "Participated in code reviews, performance tuning and system integration support",
      ],
      technologies: [".NET", "SQL Server", "Redis", "RabbitMQ", "Docker"],
    },
    {
      id: "fanxipan",
      company: "Fanxipan Technology Solutions Joint Stock Company",
      position: "Senior Developer",
      period: "06/2021 - 12/2022",
      duration: "1 year 6 months",
      description:
        "Centralized approval system — digitizing business processes for major clients.",
      responsibilities: [
        "Developed enterprise workflow apps for major clients (Vingroup, TPBank, BSH, Fecon)",
        "Implemented notification, approval, and caching modules",
        "Built and maintained CI/CD pipeline with Fastlane and CodePush",
        "Collaborated with backend engineers to optimize API integration and UX consistency",
        "BSH Digital Signature Management System (ASP.NET Core)",
      ],
      technologies: [
        "React Native",
        "ASP.NET Core",
        "Firebase",
        "Fastlane",
        "CodePush",
      ],
    },
    {
      id: "ceti",
      company: "CETI Technology Joint Stock Company",
      position: "Mobile Developer",
      period: "08/2020 - 05/2021",
      duration: "10 months",
      description:
        "AnPha Petroleum Group – Warehouse Management System.",
      responsibilities: [
        "Built warehouse import/export management for AnPha Petroleum Group",
        "Built status scanning and coordination modules for oil storage monitoring",
        "Integrated Realm and Firebase for real-time synchronization and local caching",
        "Delivered stable mobile builds for internal distribution",
      ],
      technologies: ["React Native", "Firebase", "Realm"],
    },
    {
      id: "revo",
      company: "Revo Software Company",
      position: "Fresher React Native",
      period: "06/2019 - 12/2019",
      duration: "7 months",
      description:
        "Preschool Management App (Yen Bai Department of Education).",
      responsibilities: [
        "Developed authentication and attendance modules",
        "Gained first experience in React Native and mobile deployment",
      ],
      technologies: ["React Native"],
    },
    {
      id: "moodmade",
      company: "MoodMade (Freelance)",
      position: "Founder & Fullstack / Mobile Developer",
      period: "07/2025 - 09/2025",
      duration: "3 months",
      description:
        "A cross-platform mood-tracking & mental health app with AI-powered insights and premium membership.",
      responsibilities: [
        "Architected full system: backend API, mobile app, AI suggestion module",
        "Implemented analytics dashboards, subscriptions, and user journaling features",
        "Deployed CI/CD pipelines and app stores management",
        "Enhanced UX through AI-driven personalization and optimized subscription flows for conversion and retention",
      ],
      technologies: [
        "React Native",
        "NestJS",
        "MongoDB",
        "Redis",
        "Firebase",
        "S3",
        "Queue",
        "Swift/Kotlin Native Modules",
      ],
    },
    {
      id: "onspace",
      company: "OnSpace — MVP (Freelance)",
      position: "Fullstack Developer",
      period: "05/2025 - 06/2025",
      duration: "2 months",
      description:
        "Smart parking management system including CMS and Mobile App.",
      responsibilities: [
        "Designed and deployed full-stack infrastructure on VPS (Nginx + Docker)",
        "Built booking, location, and payment modules",
        "Developed CMS dashboard with React + MUI",
        "Implemented real-time booking and payment processing; optimized search recommendation algorithms",
      ],
      technologies: [
        "NestJS",
        "MongoDB",
        "Redis",
        "S3",
        "Firebase",
        "React Native",
        "React",
        "MUI",
        "Docker",
        "GitHub Actions",
      ],
    },
    {
      id: "tica-live",
      company: "Tica Live — MVP (Freelance)",
      position: "Fullstack Developer",
      period: "04/2025 - 05/2025",
      duration: "2 months",
      description:
        "A real-time social livestream platform with video calls and interactions.",
      responsibilities: [
        "Built API system, streaming optimization, and real-time messaging",
        "Developed mobile client for livestream and social interactions",
        "Managed socket server and performance testing",
        "Optimized WebRTC via Mediasoup; resolved critical Android memory leaks to improve stability",
      ],
      technologies: [
        "NestJS",
        "React Native",
        "WebRTC",
        "Mediasoup",
        "Socket.IO",
        "MongoDB",
        "Redis",
      ],
    },
    {
      id: "go-e",
      company: "Go-E Technology Solutions (Freelance)",
      position: "Freelance React Native Developer",
      period: "07/2022 - 09/2022",
      duration: "3 months",
      description:
        "Livestream and e-commerce features for Lilly Luta and AB Beauty World apps.",
      responsibilities: [
        "Developed livestream and e-commerce features for Lilly Luta and AB Beauty World apps",
        "Integrated VNPAY, social live streaming (Facebook, YouTube), and custom filter modules",
        "Optimized streaming via WebRTC and native video modules",
      ],
      technologies: [
        "React Native",
        "VNPAY",
        "WebRTC",
        "Facebook API",
        "YouTube API",
      ],
    },
    {
      id: "nano",
      company: "Nano Travel (Freelance)",
      position: "Remote React Native Developer",
      period: "02/2020 - 06/2020",
      duration: "5 months",
      description: "Flane Travel App for booking and travel discovery.",
      responsibilities: [
        "Developed Flane Travel App for booking and travel discovery",
        "Integrated social login (Facebook/Google) and push notification system",
        "Upgraded RN version (0.59 → 0.64) and improved app performance",
      ],
      technologies: [
        "React Native",
        "Firebase",
        "Social Login",
        "Push Notification",
      ],
    },
  ],
};
